<template>
  <NavHeader />

  <RouterView v-slot="{ Component, route }">
    <Transition name="page" mode="out-in">
      <component :is="Component" :key="route.fullPath" />
    </Transition>
  </RouterView>
</template>

<script>
import NavHeader from "./components/NavHeader.vue";

export default {
  name: "App",
  components: { NavHeader },
};
</script>

<style>
#app
{
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

/* Page transition */
.page-enter-active,
.page-leave-active
{
  transition: opacity 180ms ease, transform 180ms ease;
}

.page-enter-from,
.page-leave-to
{
  opacity: 0;
  transform: translateY(6px);
}

/* optional: reduce motion */
@media (prefers-reduced-motion: reduce)
{

  .page-enter-active,
  .page-leave-active
  {
    transition: none;
  }

  .page-enter-from,
  .page-leave-to
  {
    opacity: 1;
    transform: none;
  }
}
</style>